<script lang="ts">
  import { useAuth } from '@/ui/components/auth/use-auth.svelte';

  import Profile from '../profile/Profile.svelte';

  let [authState, { logOut }] = useAuth();
</script>

<div class="fc shrink-0 grow-0 basis-auto gap-4">
  {#if authState.current.loggedIn}
    <Profile profile={authState.current.user} {logOut} />
  {/if}
</div>
